/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { FilterValueSchemaMode } from './filterValueSchemaMode';
import type { FilterValueSchemaScope } from './filterValueSchemaScope';

export interface FilterValueSchema {
  canonical_id?: number | null;
  text?: string | null;
  mode?: FilterValueSchemaMode;
  required?: boolean;
  scope?: FilterValueSchemaScope;
}
